import { render, staticRenderFns } from "./headerTpl.vue?vue&type=template&id=68868aa0&scoped=true&"
import script from "./headerTpl.vue?vue&type=script&lang=js&"
export * from "./headerTpl.vue?vue&type=script&lang=js&"
import style0 from "./headerTpl.vue?vue&type=style&index=0&id=68868aa0&prod&lang=less&scoped=true&"
import style1 from "./headerTpl.vue?vue&type=style&index=1&id=68868aa0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68868aa0",
  null
  
)

export default component.exports